export default __webpack_public_path__ + "static/media/schedule.e58c3415.svg";